import { useScope } from "~/hooks/useScope";
import { PlatformPolicyDetailPage } from "~/pages/platform/policy/PlatformPolicyDetailPage";

export function PlatformPolicyDetailEntryPage() {
  const { regionScope } = useScope();
  return regionScope ? (
    <PlatformPolicyDetailPage scope={regionScope} />
  ) : undefined;
}
